import React from 'react';
import Sidebar from '../../components/Sidebar';
import FeatureConfig from '../../components/FeatureConfig';
import './FeatureConfigPage.css';

const FeatureConfigPage = () => {
  return (
    <div className="feature-config-page cms">
      <div className="main-content">
        <Sidebar />
        <div className="content">
          <FeatureConfig />
        </div>
      </div>
    </div>
  );
};

export default FeatureConfigPage;
